import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";
import About from "@/components/About";
import Home from "@/components/Home";
import Favorites from "@/components/Favorites";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/Favorites",
      name: "Favorites",
      component: Favorites
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ x: 0, y: 0 });
    //   }, 500);
    // });
    return { x: 0, y: 0 };
  }
});

// 路由文件，配置着 url 路径 和 页面的关系



// WEBPACK FOOTER //
// ./src/router/index.js